import React from 'react';
import { Mic, MessageSquare, ShieldAlert, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
const features = [{
  num: '01',
  icon: <Mic className="w-7 h-7 text-accent-yellow" data-id="element-1" />,
  title: 'The Audio-Mirror Method',
  description: "Sound confident even when you're panicking inside. This technique rewires how you project your voice and presence in real-time."
}, {
  num: '02',
  icon: <MessageSquare className="w-7 h-7 text-accent-orange" data-id="element-2" />,
  title: "The 50 'Survival Scripts'",
  description: 'Exact phrases for ordering at bars, handling rude neighbors, crushing workplace small talk, and 47 more situations that define your social life.'
}, {
  num: '03',
  icon: <ShieldAlert className="w-7 h-7 text-accent-yellow" data-id="element-3" />,
  title: "The 'Wait, What?' Shield",
  description: 'Handle not understanding a word without looking like a confused student. Turn confusion into a conversation starter.'
}, {
  num: '04',
  icon: <Zap className="w-7 h-7 text-accent-orange" data-id="element-4" />,
  title: 'The 3-Second Rule',
  description: 'The psychological trick to kill the English Freeze before it starts. Works in any situation, any accent, any anxiety level.'
}];
export function FeaturesSection() {
  return <section className="py-24 bg-background" data-id="element-5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-7">
          <p className="text-accent-yellow font-bold tracking-widest uppercase text-sm mb-3" data-id="element-8">
            What's Inside
          </p>
          <h2 className="font-heading text-5xl md:text-7xl text-primary mb-4" data-id="element-9">
            FOUR WEAPONS.{' '}
            <span className="text-accent-yellow" data-id="element-10">ONE MISSION.</span>
          </h2>
          <p className="text-muted text-lg" data-id="element-11">
            Stop nodding. Start owning the room.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-12">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} className="p-8 rounded-2xl bg-surface border border-border hover:border-accent-yellow/30 transition-colors duration-300 group relative overflow-hidden" data-id="element-13">
              <span className="absolute top-6 right-6 font-heading text-6xl text-accent-yellow/8 select-none" data-id="element-14">
                {feature.num}
              </span>
              <div className="mb-5 p-3 bg-background rounded-xl inline-block border border-border group-hover:border-accent-yellow/20 transition-colors" data-id="element-15">
                {feature.icon}
              </div>
              <h3 className="font-heading text-2xl text-primary mb-3 group-hover:text-accent-yellow transition-colors" data-id="element-16">
                {feature.title}
              </h3>
              <p className="text-muted leading-relaxed" data-id="element-17">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}